module.exports = __webpack_public_path__ + "static/media/add.e52c48b0.svg";